import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import './style.css'

function Link(props) {
  let className = 'link-wrapper'
  const to = props.to || ''

  className = props.underlined || false ? className + ' underlined' : className

  return (
    <div className={className}>
      <RouterLink to={to}>{props.text}</RouterLink>
    </div>
  )
}

export default Link



// WEBPACK FOOTER //
// ./src/Components/Link/index.js